import { moduleFactory } from "@/factories/module";
import { _determineDevicePlatform } from "@/modules/device/determinePlatform";

export const deviceModule = moduleFactory.create({
  determinePlatform: _determineDevicePlatform,
});
